var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero'),_c('a',{staticClass:"navbar-pagelink",attrs:{"id":"services"}}),_c('services'),_c('a',{staticClass:"navbar-pagelink",attrs:{"id":"clients"}}),_c('clients'),_c('a',{staticClass:"navbar-pagelink",attrs:{"id":"about-me"}}),_c('about')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }